import { Injectable } from "@angular/core";
import { databases, ID, storage } from "../config/appwrite";
import { environment } from "../../../environments/environment";
import { Servicio } from "../models";
import { Query } from "appwrite";

@Injectable({
  providedIn: "root",
})
export class PaquetesAdquiridosService {
  private collectionId = "paquetes_adquiridos";
  private DATABASE_NAME = environment.databaseName;

  constructor() {}

  /**
   * @getData()
   * @returns
   */
  getData(): Promise<Servicio[]> {
    return databases
      .listDocuments<Servicio>(this.DATABASE_NAME, this.collectionId)
      .then((response) => response.documents);
  }

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument(data: any) {
    return databases.createDocument(
      this.DATABASE_NAME,
      this.collectionId,
      ID.unique(),
      data
    );
  }

  /**
   * getPaquetes();
   * @returns
   */
  getDataByPaciente(idPaciente: string): Promise<Servicio[]> {
    return databases
      .listDocuments<Servicio>(
        this.DATABASE_NAME,
        this.collectionId,
        // [Query.equal('idPaciente', idPaciente), Query.equal('activo', true), Query.greaterThan('citasRestantes', 0)]
        [
          Query.equal("idPaciente", idPaciente),
          Query.greaterThan("citasRestantes", 0),
        ]
      )
      .then((response) => response.documents);
  }

  /**
   *
   * @param id
   * @param data
   * @returns
   */
  updateDocument(id: string, data: any) {
    return databases.updateDocument(
      this.DATABASE_NAME,
      this.collectionId,
      id,
      data
    );
  }

  // Función para devolver un paquete cuando se cancela o se reprograma una cita y se uso uno paquete.
  devolverPaquete(idPaciente: string) {
    // 1. Consultar el último paquete comprado por el paciente
    var paquetes = databases
      .listDocuments(this.DATABASE_NAME, this.collectionId, [
        Query.equal("idPaciente", idPaciente),
        Query.orderDesc("fCompra"),
        Query.limit(1),
      ])
      .then((response) => {
        response.documents;

        if (response.documents.length > 0) {
          var ultimo_paquete = response.documents[0];

          //Sumar 1 a las citas restantes
          var nuevas_citas_restantes = ultimo_paquete["citasRestantes"] + 1;

          // Actualizar el documento
          databases.updateDocument(
            this.DATABASE_NAME,
            this.collectionId,
            ultimo_paquete["$id"],
            {
              citasRestantes: nuevas_citas_restantes,
            }
          );
        }
      });

    return true;
  }
}
